module.exports = __webpack_public_path__ + "img/carshinaused_14.4bfff9f9.jpg";